(function(){
  function init(root){
    if(!root || root.dataset.skBound==='1') return;
    root.dataset.skBound='1';
    var scene=root.querySelector('[data-hero-scene]');
    if(scene){
      scene.addEventListener('mousemove',function(e){
        var r=scene.getBoundingClientRect();
        var x=(e.clientX-r.left)/r.width-.5;
        var y=(e.clientY-r.top)/r.height-.5;
        root.style.setProperty('--rx',(-y*8)+'deg');
        root.style.setProperty('--ry',(-12+x*12)+'deg');
        root.style.setProperty('--mx',(x*22)+'px');
        root.style.setProperty('--my',(y*16)+'px');
      });
      scene.addEventListener('mouseleave',function(){
        root.style.setProperty('--rx','0deg');
        root.style.setProperty('--ry','-12deg');
        root.style.setProperty('--mx','0px');
        root.style.setProperty('--my','0px');
      });
    }
    function onScroll(){
      var rect=root.getBoundingClientRect();
      var progress=Math.max(0,Math.min(1,1-rect.top/(window.innerHeight||1)));
      root.style.setProperty('--orbit',(progress*24)+'deg');
      root.style.setProperty('--rz',(progress*2.5)+'deg');
      root.style.setProperty('--heroShift',(progress*-12)+'px');
    }
    onScroll();
    window.addEventListener('scroll',onScroll,{passive:true});
    root.querySelectorAll('.faq-toggle').forEach(function(btn){
      btn.addEventListener('click',function(){ btn.parentElement.classList.toggle('active'); });
    });
  }
  function boot(){ document.querySelectorAll('[data-sk-v4]').forEach(init); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
  document.addEventListener('shopify:section:load',boot);
})();